import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "./styles.css";

function ImageViewer({
  imageUrl = "",
  imageAlt = "image by twika",
  imageType,
  width,
  height,
  onDoubleClick = () => {
    console.log("No double click handler");
  },
}) {
  const [hasImgLoaded, sethasImgLoaded] = useState(false);

  return (
    <>
      {hasImgLoaded ? null : (
        <>
          {imageType === "post" ? (
          <div className="w-full bg-gray-100" style={{height:'400px'}}></div>
            // <Skeleton width={'100%'} height={400} />
          ) : (
            <Skeleton circle={true} width={width} height={height} />
          )}
        </>
      )}

      <div
        className={imageType === "post" ? "bg-black image-post-container" : ""}
      >
        {imageType === "post" && (
          <button onClick={() => {}} className="resize-icon"></button>
        )}

        <img
          src={imageUrl}
          onLoad={() => sethasImgLoaded(true)}
          alt={imageAlt}
          className={
            "object-cover image-to-display " +
            (imageType === "post" ? " image-post " : " image-profile ") +
            (!hasImgLoaded ? " d-none " : "")
          }
          style={
            imageType === "post"
              ? { width: "700px", height: height + "px" }
              : {
                  height: height !== 0 ? height + "px" : "25px",
                  width: width !== 0 ? width + "px" : "100%",
                }
          }
          onError={(e) => {
            e.target.src =
              "data:image/png;base64,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";
          }}
          onDoubleClick={onDoubleClick}
        />
      </div>
    </>
  );
}

export default ImageViewer;
